import useAxios from 'hooks/useAxios';

/**
 * Get general giveaway information (public endpoint)
 */
export async function getGiveawayInfo() {
  const api = useAxios();

  try {
    const res = await api.get('/giveaway/info');
    return res;
  } catch (err) {
    return err;
  }
}
